import { render, staticRenderFns } from "./list_mindsets_component.vue?vue&type=template&id=19910500&scoped=true"
import script from "./list_mindsets_component.vue?vue&type=script&lang=js"
export * from "./list_mindsets_component.vue?vue&type=script&lang=js"
import style0 from "./list_mindsets_component.vue?vue&type=style&index=0&id=19910500&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19910500",
  null
  
)

export default component.exports